import React from 'react';
import { cn } from '../../utils/lib/utils';

export function Container({ className, ...props }) {
  return (
    <div
      className={cn(
        'mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8',
        className
      )}
      {...props}
    />
  );
} 